import React from "react";
import { Button } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import DialogTitle from "@material-ui/core/DialogTitle";

export default function DeleteDomainReportDialog({
  isOpenDeleteReportDialog,
  setIsOpenDeleteReportDialog,
  handleCompleteDeleteDomainReport,
  handleCloseDeleteDomainReport,
}) {
  return (
    <Dialog
      open={isOpenDeleteReportDialog}
      onClose={handleCloseDeleteDomainReport}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Delete Report"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete this report?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCompleteDeleteDomainReport} color="primary">
          Delete
        </Button>
        <Button
          onClick={() => {
            setIsOpenDeleteReportDialog(false);
          }}
          color="primary"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
